import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { I18nProvider } from "./lib/i18n";
import { queryClient } from "./lib/query-client";
import { ThemeProvider } from "./lib/theme";
import "./index.css";

// Provider order matters:
//   QueryClient → I18n (needs useMe) → Theme → Router → App
// I18n bootstraps its lang from localStorage/navigator on first paint, then
// reconciles with the server once `useMe` resolves — so it has to sit inside
// the QueryClient but doesn't need to know about routing.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <ThemeProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
        </ThemeProvider>
      </I18nProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
